module.exports = __webpack_public_path__ + "static/media/repairTypes.89308196.png";